export const CALENDAR_GET_EVENTS = "CALENDAR_GET_EVENTS";
export const CALENDAR_ADD_EVENT = "CALENDAR_ADD_EVENT";
export const CALENDAR_UPDATE_EVENT = "CALENDAR_UPDATE_EVENT";
export const CALENDAR_SEARCH_EVENTS = "CALENDAR_SEARCH_EVENTS";
